








































































import BaseComponent from '@/components/base-component.vue';
import { FiltroSituacaoClinicaDTO } from '@/interfaces/therapy';
import { listClinicSituations } from '@/services/therapy';
import Component from 'vue-class-component';
import { Prop, Watch } from 'vue-property-decorator';

@Component
export default class UiAutocompleteClinicsSituations extends BaseComponent {
  @Prop({ default: () => [] })
  public value: any;

  @Prop({ default: 'Situações Clinicas' })
  public label?: string;

  @Prop({ default: 'Escolha uma ou mais Situações Clínicas' })
  public placeholder?: string;

  @Prop({ default: false })
  public required?: boolean;

  @Prop({ default: false })
  public disabled?: boolean;

  @Prop({ default: true })
  public returnObject?: boolean;

  @Prop({ default: false })
  public closeOnContentClick?: boolean;

  @Prop({ default: () => [] })
  private rules?: any[];

  @Prop()
  public filters: FiltroSituacaoClinicaDTO;

  loading = false;
  error = false;
  clinicSituations = [];
  items = [];

  mounted() {
    this.loadClinicSituations();
  }

  public onChange(val) {
    this.$emit('input', val);
    this.$emit('change', val);
  }

  private loadClinicSituations(): void {
    this.loading = true;
    listClinicSituations(this.filters).subscribe((res) => {
      this.items = res;
      this.loading = false;
      setTimeout(() => {
        this.clinicSituations = [];
        this.items.forEach((cs) => {
          if (this.returnObject) {
            if (this.value.findIndex((s) => cs.id == s.id) != -1) {
              this.clinicSituations.push(cs);
            }
          } else {
            if (this.value.findIndex((s) => cs.id == s) != -1) {
              this.clinicSituations.push(cs.id);
            }
          }
        });
        this.onChange(this.clinicSituations);
      }, 10);
    });
  }

  public removeClinicSituations(item) {
    let index = this.clinicSituations.indexOf(item);
    if (!this.returnObject) {
      index = this.clinicSituations.indexOf(item.id);
    }
    if (index >= 0) this.clinicSituations.splice(index, 1);
    this.onChange(this.clinicSituations);
  }

  public onLinkClick(link) {
    window.open(link, 'doclink');
  }

  lastFilter = null;
  @Watch('filters')
  onFiltersChange() {
    if (this.lastFilter && this.filters && JSON.stringify(this.lastFilter) == JSON.stringify(this.filters)) {
      return;
    }
    setTimeout(() => {
      this.lastFilter = this.filters;
      this.loadClinicSituations();
    }, 100);
  }
}
